import React from 'react';
import { Form, DatePicker } from 'antd';
import { I18n } from '@aws-amplify/core';
import { FormItemProps } from '@/components/views/Resolution886/types';

interface UploadDateFormItemProp extends FormItemProps {
    fieldName?: string | string[];
}

export function UploadDateFormItem({ fieldName, required = true, labelCol }: Readonly<UploadDateFormItemProp>) {
    return (
        <Form.Item name={fieldName} required={required} label={I18n.get('Upload date')} labelCol={labelCol}>
            <DatePicker.RangePicker
                style={{ width: '100%' }}
                format="L"
                disabledDate={(current) => current && current.valueOf() >= Date.now()}
            />
        </Form.Item>
    );
}